import ManageConfiguration from "./ManageConfiguration";

export default ManageConfiguration;
